import React from 'react';
import { translate } from '../Services/translation';

const addProduct = ({ productId, image, name, onRemove }) => (
  <div key={productId} className="compare-product-item">
    <img className="product-icon" src={image} alt={name}></img>
    <button
      className="close-button"
      onClick={() => {
        onRemove(productId);
      }}
    ></button>
  </div>
);

const CompareProductBlock = (props) => {
  const products =
    props &&
    props.comparedProducts &&
    props.comparedProducts.map((item) =>
      addProduct({
        ...item,
        onRemove: props.onRemove,
      })
    );
  return products && products.length > 0 ? (
    <div className="compare-product-block">
      <div className="compare-actions">
        <div className="compare-up-3-product">
          {translate('product.compare_up_to_3_product')}
        </div>
        <div>
          <button
            className="remove-all-button"
            onClick={() => {
              props.onRemoveAll();
            }}
          >
            {translate('product.remove_all')}
          </button>
        </div>
      </div>
      <div className="compare-products-list">{products}</div>
      <div>
        <a className="hollow button" href={props.linkToCompareProduct}>
          {translate('product.show_comparison')}
        </a>
      </div>
    </div>
  ) : null;
};

export default CompareProductBlock;
